export default __webpack_public_path__ + "static/media/banner-mais-mobile.446c9851.png";